import { useEffect } from 'react';
import { create } from 'zustand';

// Lets pages override a breadcrumb segment label (e.g. "#15" → "Tuesday Yoga").
// Keyed by full path so /admin/attendance/15 and /admin/students/15 don't clash.
interface BreadcrumbState {
  labels: Record<string, string>;
  setLabel: (path: string, label: string | undefined) => void;
}

export const useBreadcrumbStore = create<BreadcrumbState>((set) => ({
  labels: {},
  setLabel: (path, label) =>
    set((s) => {
      const next = { ...s.labels };
      if (label && label.trim()) next[path] = label;
      else delete next[path];
      return { labels: next };
    }),
}));

// Hook a page calls once it knows its display name. Cleans up on unmount so
// going back to a parent route doesn't keep a stale label.
export function useCrumbLabel(path: string | undefined, label: string | undefined) {
  const setLabel = useBreadcrumbStore((s) => s.setLabel);
  useEffect(() => {
    if (!path) return;
    setLabel(path, label);
    return () => setLabel(path, undefined);
  }, [path, label, setLabel]);
}
